/**
 * Table Element Renderer
 */

import { BaseElementRenderer, type ElementRenderContext } from './base-element-renderer';
import { InvoiceTablePreview } from '../invoice-table-preview';

export class TableRenderer extends BaseElementRenderer {
  canRender(elementType: string): boolean {
    return elementType === 'table';
  }
  
  render(context: ElementRenderContext) {
    return (
      <div 
        onClick={context.onClick} 
        style={{
          cursor: 'pointer',
          outline: context.isSelected ? '2px solid #3b82f6' : 'none',
        }}
      >
        <InvoiceTablePreview element={context.element} style={context.baseStyle} />
      </div>
    );
  }
}
